import { useI18n as useRawI18n } from 'i18next-react';
import type { i18n as I18nInstance } from 'i18next';

// i18next's TFunction generics default to `string`, but TS can widen the return
// to the broader TFunctionResult union when the call sits in a JSX children
// position under React 18's stricter ReactNode type. Every usage in this app
// treats t() as returning a string, so pin that down here in one place.
type StringT = (key: string | string[], options?: unknown) => string;

export function useI18n(): Omit<I18nInstance, 't'> & { t: StringT } {
  return useRawI18n() as Omit<I18nInstance, 't'> & { t: StringT };
}
